// import './style';
import './style/preloader';
import { h, Component } from 'preact';
import App from './components/app';


export default App

// export default class Index extends Component {
// 	state = {
// 		loaded:false
// 	}
// 	async componentDidMount() {
// 		if (!this.App) {
// 			let app = await import('./components/app');
// 			this.App = app.default;
// 			this.setState({loaded:true});
// 		}
// 	}
// 	render() {
// 		return this.state.loaded ? h(this.App) : <div id="preloader"/>
// 	}
// }



// WEBPACK FOOTER //
// ./index.js